import { useState } from "react";
import Cookie, { type CookieAttributes } from "js-cookie";

export type UseCookieStateArg<TValue = unknown> = {
    readonly cookieKey: string;
    readonly defaultValue?: TValue;
};

export default function useCookieState<TValue = unknown>({
    cookieKey,
    defaultValue
}: UseCookieStateArg<TValue>) {
    const [state, setState] = useState(() => Cookie.get(cookieKey) ?? defaultValue);

    const updateState = (
        value: TValue,
        attributes?: CookieAttributes & {
            readonly strategy?: 'remove' | 'set';
        }
    ) => {
        switch (attributes?.strategy) {
            case 'remove': {
                Cookie.remove(cookieKey, attributes);
                break;
            }

            default: {
                Cookie.set(cookieKey, `${value}`, attributes);
            }
        }

        setState(value);
    };

     return [state, updateState] as const;
};
